import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';
import {parseCurrency} from 'helpers';
import firebase from 'utils/firebase';

import Avatar from 'components/avatar';
import Login from 'components/login';
import Register from 'components/register';


class Header extends Component {
	open = (e) => {
		e.preventDefault();
		e.stopImmediatePropagation();
		this.setState({show: 'account'}, () => {
			document.body.addEventListener('click', this.close)
		})
	}
	close = () => {
		this.setState({show: null});
		document.body.removeEventListener('click', this.close)
	}
	render(props,state,context) {
		return <div class="navbar-container ">
		  <nav class={state.mobile ? "navbar navbar-expand-lg navbar-light navbar-toggled-show" : "navbar navbar-expand-lg navbar-light"}>
			<div class="container">
			  <a class="navbar-brand fade-page" href="/" style="max-width:50%;">
				  <img src="/assets/lippumaatti-logo.png" style="max-height:3rem"/>
			  </a>
			  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded={state.mobile === true ? "true": "false"} aria-label="Toggle navigation" onClick={() => this.setState({mobile: !state.mobile })}>
				<svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				  <path d="M3 17C3 17.5523 3.44772 18 4 18H20C20.5523 18 21 17.5523 21 17V17C21 16.4477 20.5523 16 20 16H4C3.44772 16 3 16.4477 3 17V17ZM3 12C3 12.5523 3.44772 13 4 13H20C20.5523 13 21 12.5523 21 12V12C21 11.4477 20.5523 11 20 11H4C3.44772 11 3 11.4477 3 12V12ZM4 6C3.44772 6 3 6.44772 3 7V7C3 7.55228 3.44772 8 4 8H20C20.5523 8 21 7.55228 21 7V7C21 6.44772 20.5523 6 20 6H4Z"
				  fill="#212529" />
				</svg>
			  </button>
			  <div class={state.mobile ? "collapse navbar-collapse justify-content-end show": "collapse navbar-collapse justify-content-end"}>
				<div class="py-2 py-lg-0">
				  <ul class="navbar-nav">
					  <li class="nav-item"><a href="/" class="nav-link">Selaa tapahtumia</a></li>
					  <li class="nav-item"><a href="/ota-yhteytta" class="nav-link">Järjestä tapahtuma</a></li>
				  </ul>

			  </div>

			  <a href="/ostoskori" class="btn btn-success ml-lg-3">
				  <svg class="icon" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
	                  <title>Icon For Heart</title>
						  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
		                    <rect opacity="0" x="0" y="0" width="24" height="24"></rect>
		                    <path d="M18.1446364,11.84388 L17.4471627,16.0287218 C17.4463569,16.0335568 17.4455155,16.0383857 17.4446387,16.0432083 C17.345843,16.5865846 16.8252597,16.9469884 16.2818833,16.8481927 L4.91303792,14.7811299 C4.53842737,14.7130189 4.23500006,14.4380834 4.13039941,14.0719812 L2.30560137,7.68518803 C2.28007524,7.59584656 2.26712532,7.50338343 2.26712532,7.4104669 C2.26712532,6.85818215 2.71484057,6.4104669 3.26712532,6.4104669 L16.9929851,6.4104669 L17.606173,3.78251876 C17.7307772,3.24850086 18.2068633,2.87071314 18.7552257,2.87071314 L20.8200821,2.87071314 C21.4717328,2.87071314 22,3.39898039 22,4.05063106 C22,4.70228173 21.4717328,5.23054898 20.8200821,5.23054898 L19.6915238,5.23054898 L18.1446364,11.84388 Z" fill="#000000" opacity="0.3"></path>
		                    <path d="M6.5,21 C5.67157288,21 5,20.3284271 5,19.5 C5,18.6715729 5.67157288,18 6.5,18 C7.32842712,18 8,18.6715729 8,19.5 C8,20.3284271 7.32842712,21 6.5,21 Z M15.5,21 C14.6715729,21 14,20.3284271 14,19.5 C14,18.6715729 14.6715729,18 15.5,18 C16.3284271,18 17,18.6715729 17,19.5 C17,20.3284271 16.3284271,21 15.5,21 Z" fill="#000000"></path>
		                  </g>
	            </svg>
				<span>{parseCurrency(context.cart.getTotal())}</span>
			  </a>
			  {context.user ?

				  <div>
					<div class="mt-2 bt-1 pt-2 d-block d-lg-none">
						<button class="btn btn-white dropdown-toggle pl-0 pl-md-2" data-toggle="dropdown" aria-haspopup="true" aria-expanded={state.show === 'account' ?  "true" : "false"} onClick={this.open}>
							<Avatar alt={context.user.displayName} name={context.user.displayName} src={context.user.photoURL} class="avatar avatar-sm"/>
							<span class="ml-2">{context.user.displayName || 'Oma tili'}</span>
						</button>
						<ul class="navbar-nav">
						   <li class="nav-item"><a href="/profiili/liput" class="nav-link">Omat liput</a></li>
						   <li class="nav-item"><a href="/profiili" class="nav-link">Omat tiedot</a></li>
						   <li class="nav-item"><a class="dropdown-item" href="/" class="nav-link" onClick={() => firebase.auth().signOut()}>Kirjaudu ulos</a></li>

					   </ul>
					</div>
					<div class="d-none d-lg-block">
						<div class="dropdown">
							<button class="btn btn-white dropdown-toggle pl-0 pl-md-2" data-toggle="dropdown" aria-haspopup="true" aria-expanded={state.show === 'account' ?  "true" : "false"} onClick={this.open}>
								<Avatar alt={context.user.displayName} name={context.user.displayName} src={context.user.photoURL} class="avatar avatar-sm"/>
								<span class="ml-2">{context.user.displayName || 'Oma tili'}</span>
							</button>
							<div class={state.show === 'account' ?  "dropdown-menu dropdown-menu-right dropdown-content show mt-0" : "dropdown-menu dropdown-menu-right dropdown-content"}>
							  <a class="dropdown-item" href="/profiili/liput">Omat liput</a>
							  <a class="dropdown-item" href="/profiili">Omat tiedot</a>
							  <a class="dropdown-item" href="/" class="dropdown-item" onClick={() => firebase.auth().signOut()}>Kirjaudu ulos</a>
							</div>
						</div>
					</div>
				  </div>
				  :
				  <button class="btn btn-white" onClick={() => this.setState({show: 'account'})}>Oma tili</button>
			  }
			</div>
			</div>
		</nav>
		{
			!context.user && state.show === 'account' && !state.register ? <Login onClose={() => this.setState({show:null})} onRegister={() => this.setState({register:true})} /> :
			!context.user && state.show === 'account' && state.register === true ? <Register onClose={() => this.setState({show:null})} onLogin={() => this.setState({register:false})}  />
			:
			null
		}
		</div>
	}
}

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js